import axios from 'axios'
import store from '@/store'
import Authent from '@/api/authent.js'

axios.defaults.baseURL = '/api'

// Request interceptor
axios.interceptors.request.use((config) => {
  // Do something before request is sent
  const token = store.state.authent.apiToken
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

let createAxiosResponseInterceptor = () => {
  const interceptor = axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      // Reject promise if usual error
      const status = error.response ? error.response.status : null
      if (status !== 401 && error.response.data.code !== 'two_many_login') {
        return Promise.reject(error)
      }

      /*
       * When response code is 401, try to refresh the token.
       * Eject the interceptor so it doesn't loop in case
       * token refresh causes the 401 response
       */
      axios.interceptors.response.eject(interceptor)

      try {
        const response = await Authent.refreshToken(
          store.state.authent.refreshToken, function (error) {
            store.commit('authent/disconnect')
            debugger
            return router.push({
              name: 'login', query: { error: true, redirect: router.currentRoute.fullPath },
            })
          }
        )
        store.commit('authent/setApiToken', {
          access: response.access,
          refresh: store.state.authent.refreshToken
        })
        const authorization = `Bearer ${store.state.authent.apiToken}`
        error.config.headers['Authorization'] = authorization
        error.config.baseURL = undefined
      } catch (error) {
        return Promise.reject(new Error('disconnect'))
      } finally {
        createAxiosResponseInterceptor()
      }
      return axios(error.config)
    }
  )
}

createAxiosResponseInterceptor()
